import React, { useState, useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Input } from "@mui/material";
import useStyles from "../../components/Forms/user-jss";
import InputLabel from "@mui/material/InputLabel";
import ValidationUtil from "../Validation/ValidationUtil";
import Services from "../../Services/Services";
import MainContext from "../../Services/Context/MainContext";
import Swal from "sweetalert2";
import { userLogout } from "../../Services/UserUtil";

const ResetPassword = () => {
  const { classes, cx } = useStyles();
  const initialState = {
    fields: {},
    errors: {},
  };

  const [open, setOpen] = useState(false);
  const [getPasswordDetails, setPasswordDetails] = useState(initialState);
  const allContextDetails = useContext(MainContext);
  const [getEmailOTPCode, setEmailOTPCode] = useState("");
  const [getEmailVerifyKey, setEmailVerifyKey] = useState("");
  const [emailOtpBtn, setEmailOtpBtn] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState(false);
  const [getErrorMsg, setErrorMsg] = useState({});
  const [showPasswordValue, setShowPasswordValue] = useState(false);
  const [showConfirmPasswordValue, setShowConfirmPasswordValue] =
    useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    let fields = getPasswordDetails.fields;
    fields[e.target.name] = e.target.value;
    setPasswordDetails({ ...getPasswordDetails, fields });
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Tab") {
        // console.log("Tab clicked");
        event.stopPropagation();
        event.preventDefault();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  const required = (value) => (value === null ? "Required" : undefined);

  const passwordsMatch = (value, getPasswordDetails) => {
    if (value !== getPasswordDetails.field.password) {
      // console.log("match");
      return "Passwords do not match";
    }
    return undefined;
  };
  const togglePasswordVisibility = () => {
    setShowPasswordValue(!showPasswordValue);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPasswordValue(!showConfirmPasswordValue);
  };

  const onPasswordChange = () => {
    let fields = getPasswordDetails.fields;
    let errors = getPasswordDetails.errors;
    if (!ValidationUtil.isRequired(fields["password"])) {
      errors["password"] = "*Password can't be empty";
    } else if (!ValidationUtil.passwordCharacters(fields["password"])) {
      errors["password"] = "*Password must be at least 5 characters";
    } else if (!ValidationUtil.isStrongPassword(fields["password"])) {
      errors["password"] =
        "*Password must contain (uppercase, lowercase, digits, special characters)";
    } else {
      delete errors["password"];
    }

    setPasswordDetails({ ...getPasswordDetails, errors });
  };
  const onOldPasswordChange = () => {
    let fields = getPasswordDetails.fields;
    let errors = getPasswordDetails.errors;
    if (!ValidationUtil.isRequired(fields["old_password"])) {
      errors["old_password"] = "*Please Enter Your Old Password ";
    } else {
      delete errors["old_password"];
    }

    setPasswordDetails({ ...getPasswordDetails, errors });
  };

  const onConfirmPassword = () => {
    let fields = getPasswordDetails.fields;
    let errors = getPasswordDetails.errors;
    if (fields["password"] != fields["confirm_password"]) {
      //   console.log("do not match");
      errors["confirm_password"] = "*Password do not match";
    } else if (fields["password"] === fields["confirm_password"]) {
      delete errors["confirm_password"];
    } else {
      delete errors["confirm_password"];
    }
  };

  const validate = () => {
    let fields = getPasswordDetails.fields;
    let errors = {};
    let formIsValid = true;

    // if (!ValidationUtil.isContactNumber(fields["mobileno"])) {
    //   formIsValid = false;
    //   errors["mobileno"] = "*Please enter mobile number";
    // } else
    if (fields["password"] != fields["confirm_password"]) {
      formIsValid = false;
      errors["confirm_password"] = "*Password do not match";
    }
    // else if (ValidationUtil.isStrongPassword(fields["password"])) {
    //   formIsValid = false;
    //   errors["password"] = "*Make a strong password";
    // }
    setPasswordDetails({ ...getPasswordDetails, errors });

    return formIsValid;
  };

  const generateEmailOTP = async (e) => {
    e.preventDefault();
    if (validate()) {
      const bodyjson = {
        mail: allContextDetails.email,
        otp_secret_key:
          "B6X4PMZWWBBNMKWHKGHLI7YMBAMDKYYDLZQFYV5AWX5ASRWPDK4Q====",
      };
      const emailOTPSubmit = async () => {
        try {
          const response = await Services.generateOTPforResetPW(bodyjson);
          if (response.status === 200) {
            // console.log("email otp", response);
            // const email_otpCode = response.data.data.code;
            const email_verifyKey = response.data.data.verifyKey;
            // setEmailOTPCode(email_otpCode);
            setEmailVerifyKey(email_verifyKey);
            setEmailOtpBtn(true);
          }
        } catch (err) {
          if (err.response.status === 429) {
            setOpen(false);
            Swal.fire({
              title: "Warning",
              // text: err,
              text: "Request is blocked for next 24 Hours, please try again",
              icon: "warning",
            }).then(() => {
              setOpen(true);
            });
          } else {
            setOpen(false);
            Swal.fire({
              title: "Error",
              // text: err,
              text: err.response.status === 500 ? "Server not reachable" : err,
              icon: "error",
            }).then(() => {
              setOpen(true);
            });
          }
        }
      };
      emailOTPSubmit();
    }
  };
  // console.log("open", open);

  const verifyEmailOtp = async (e) => {
    e.preventDefault();
    // if (validate()) {
    const { otp_code } = getPasswordDetails.fields;
    const bodyjson = {
      mail: allContextDetails.email,
      otp_secret_key:
        "B6X4PMZWWBBNMKWHKGHLI7YMBAMDKYYDLZQFYV5AWX5ASRWPDK4Q====",
      otp_code: otp_code,
      verifyKey: getEmailVerifyKey,
    };
    const verifyEmailOTPSubmit = async () => {
      try {
        const response = await Services.verifyOTPforResetPW(bodyjson);
        // console.log("reess", response);
        if (response.status === 200) {
          setEmailIsValid(true);
        }
      } catch (err) {
        // console.log("pw", err.response);
        setOpen(false);
        Swal.fire({
          title: "Error",
          text:
            err.response.status === 500
              ? "Server not reachable"
              : err.response.data.errors,
          icon: "error",
        }).then(() => {
          setOpen(true);
        });
      }
    };
    verifyEmailOTPSubmit();
    // }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const { old_password, password, confirm_password } =
        getPasswordDetails.fields;
      const bodyjson = {
        password,
        confirm_password,
        email: allContextDetails.email,
      };
      const updatePassword = async () => {
        try {
          const response = await Services.resetPassword(bodyjson);
          if (response.status === 200) {
            // console.log("upate pw res", response);
            Swal.fire({
              title: "Success!",
              text: `${response.data.message}`,
              icon: "success",
            });
          }
        } catch (err) {
          const errorMsg =
            err.response?.data.message ||
            err.response?.data.errors ||
            err.response?.data.detail ||
            err.response.data;
          setErrorMsg(errorMsg);
          let errorMessage = "";
          if (typeof errorMsg === "object" && !Array.isArray(errorMsg)) {
            Object.keys(errorMsg).forEach((field) => {
              let readableField =
                field.replace(/_/g, " ").charAt(0).toUpperCase() +
                field.replace(/_/g, " ").slice(1);

              if (Array.isArray(errorMsg[field])) {
                errorMsg[field].forEach((message) => {
                  // errorMessage += `${readableField}: ${message}\n`;
                  errorMessage += `${message}\n`;
                });
              } else {
                // errorMessage += `${readableField}: ${errorMsg[field]}\n`;
                errorMessage += ` ${errorMsg[field]}\n`;
              }
            });
          } else {
            errorMessage = errorMsg;
          }
          if (err.response.status === 400) {
            Swal.fire({
              title: "Error",
              text: errorMessage || err.response.data.errors,
              icon: "error",
            }).then(() => {
              setOpen(true);
            });
          } else if (
            err.response.status === 501 ||
            errorMsg.status_code === 501
          ) {
            Swal.fire({
              title: "Error",
              text: err.response.data.errors || errorMessage,
              icon: "error",
            }).then(() => {
              setOpen(true);
            });
          } else {
            Swal.fire({
              title: "Error",
              text: errorMessage || err.response.data.errors,
              icon: "error",
            }).then(() => {
              setOpen(true);
            });
          }
        }
      };
      updatePassword();
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Tab") {
      // e.preventDefault(); // Prevent default tab behavior
      e.stopPropagation(); // Stop event propagation
    }
  };

  return (
    <div>
      <div onClick={handleClickOpen}>Set your Password</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        className={classes.passResetDialog}
        disableEnforceFocus
        disableEscapeKeyDown
        disableAutoFocus
        disableRestoreFocus
        onKeyDown={handleKeyDown}
      >
        <DialogTitle id="form-dialog-title">Set Password </DialogTitle>
        <form
          onSubmit={formSubmit}
          // onKeyDown={handleKeyPress}
          onKeyDown={(e) => {
            if (e.key === "Tab") {
              e.preventDefault();
            }
          }}
          onKeyUp={handleKeyPress}
        >
          <DialogContent>
            <DialogContentText className="text-center">
              Need to set your password? No Problem!, Now you can create your
              new password.
            </DialogContentText>
            {/* <div>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor="old_password"> Old Password</InputLabel>
                <Input
                  name="old_password"
                  label="old password"
                  id="old_password"
                  placeholder="Old Password"
                  required
                  autoComplete="off"
                  validate={[required, passwordsMatch]}
                  type="password"
                    value={getPasswordDetails.fields.password}
                  onChange={handleChange}
                  onBlur={onOldPasswordChange}
                  className={`${classes.field} ${
                    getPasswordDetails.errors.old_password === undefined
                      ? ""
                      : "wrongValue"
                  }`}
                />
                <span className="errorMsg text-left text-danger">
                  {getPasswordDetails.errors["old_password"]}
                </span>
              </FormControl>
            </div> */}
            <div className="form-inputs justify-content-center align-items-center flex-column">
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor="email">Email</InputLabel>
                <Input
                  name="email"
                  label="Email"
                  id="email"
                  placeholder={allContextDetails.email}
                  required
                  autoComplete="off"
                  validate={[required, passwordsMatch]}
                  type="email"
                  value={allContextDetails.email}
                  onChange={handleChange}
                  // onBlur={onPasswordChange}
                  className={`${classes.field} ${
                    emailIsValid ? "valid-email" : ""
                  }`}
                  // className={`${classes.field} ${
                  //   getPasswordDetails.errors.email === undefined
                  //     ? ""
                  //     : "wrongValue"
                  // }`}
                />
              </FormControl>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor="mobileno">Mobile No</InputLabel>
                <Input
                  name="mobileno"
                  label="mobileno"
                  id="mobileno"
                  placeholder={allContextDetails.mobileno}
                  required
                  autoComplete="off"
                  // validate={[required, passwordsMatch]}
                  type="text"
                  value={allContextDetails.mobileno}
                  onChange={handleChange}
                  // onBlur={onPasswordChange}
                  // className={`${classes.field} ${
                  //   emailIsValid ? "valid-email" : ""
                  // }`}
                  // className={`${classes.field} ${
                  //   getPasswordDetails.errors.email === undefined
                  //     ? ""
                  //     : "wrongValue"
                  // }`}
                />
              </FormControl>
              <Button
                variant="outlined"
                color="primary"
                onClick={generateEmailOTP}
                disabled={emailIsValid}
                className={classes.generateOTP}
              >
                {!emailOtpBtn ? "Generate OTP" : "Resend"}
              </Button>
            </div>
            <div className="text-left">
              <span className="errorMsg text-left text-danger">
                {getPasswordDetails.errors["mail"]}
              </span>
            </div>
            <div>
              {!!emailOtpBtn ? (
                <div className="form-inputs">
                  <FormControl
                    variant="standard"
                    className={`${classes.formControl} form-contol-input pr-1 `}
                  >
                    {/* <label >Username</label> */}
                    <InputLabel htmlFor="email_otp" className="required-label ">
                      Email/Mobile OTP
                    </InputLabel>
                    <Input
                      name="otp_code"
                      label="Email OTP"
                      type="text"
                      id="email_otp"
                      placeholder="Email OTP"
                      required
                      autoComplete="off"
                      onChange={handleChange}
                    />
                  </FormControl>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={verifyEmailOtp}
                  >
                    Verify Email
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
            <div>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor="new_password"> New Password</InputLabel>
                <Input
                  name="password"
                  label="new password"
                  id="new_password"
                  placeholder="New Password"
                  required
                  autoComplete="off"
                  validate={[required, passwordsMatch]}
                  // type="password"
                  //   value={getPasswordDetails.fields.password}
                  type={showPasswordValue ? "text" : "password"}
                  onChange={handleChange}
                  onBlur={onPasswordChange}
                  className={`${classes.field} ${
                    getPasswordDetails.errors.password === undefined
                      ? ""
                      : "wrongValue"
                  }`}
                />
                <span className="eyeBtn" onClick={togglePasswordVisibility}>
                  {showPasswordValue ? (
                    <i className="ion-md-eye"></i>
                  ) : (
                    <i className="ion-md-eye-off"></i>
                  )}
                </span>
                <span className="errorMsg text-left text-danger">
                  {getPasswordDetails.errors["password"]}
                </span>
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor="confirm_password">
                  Confirm Password
                </InputLabel>
                <Input
                  name="confirm_password"
                  label="confirm password"
                  id="confirm_password"
                  placeholder="Confirm Password"
                  required
                  autoComplete="off"
                  validate={[required, passwordsMatch]}
                  type={showConfirmPasswordValue ? "text" : "password"}
                  // type="password"
                  //   value={getPasswordDetails.fields.password}
                  onChange={handleChange}
                  onBlur={onConfirmPassword}
                  className={`${classes.field} ${
                    getPasswordDetails.errors.confirm_password === undefined
                      ? ""
                      : "wrongValue"
                  }`}
                />
                <span
                  className="eyeBtn"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPasswordValue ? (
                    <i className="ion-md-eye"></i>
                  ) : (
                    <i className="ion-md-eye-off"></i>
                  )}
                </span>
                <span className="errorMsg text-left text-danger">
                  {getPasswordDetails.errors["confirm_password"]}
                </span>
              </FormControl>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button disabled={!emailIsValid} color="primary" type="submit">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default ResetPassword;
